<div class="wrapper">
    <h1>Add Your School</h1>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal()"
    >
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="information-box">
        <div class="note">
            Help us improve our list of schools in the country. If you think
            your school is not in our list yet, please add it here.
        </div>
        <app-input-box
            label="School Name *"
            [(inputModel)]="suggestedSchool.name"
        ></app-input-box>
        <app-error-message
            *ngIf="!suggestedSchool.name && isSubmitted"
        ></app-error-message>
        <app-input-box
            label="School Zip Code *"
            [(inputModel)]="suggestedSchool.zipCode"
        ></app-input-box>
        <app-error-message
            *ngIf="!suggestedSchool.zipCode && isSubmitted"
        ></app-error-message>
        <div class="address">
            <app-input-box
                label="Address"
                [(inputModel)]="suggestedSchool.address"
            ></app-input-box>
            <div class="city-input-wrapper">
                <app-input-box
                    label="City"
                    [(inputModel)]="suggestedSchool.city"
                ></app-input-box>
            </div>
        </div>
        <div class="states-selector-wrapper">
            <ng-select
                [items]="states"
                bindLabel="name"
                dropdownPosition="bottom"
                [multiple]="false"
                [hideSelected]="false"
                [searchable]="false"
                [clearable]="false"
                [markFirst]="true"
                placeholder="Select a state"
                [(ngModel)]="suggestedSchool.state"
                class="dropdown"
            >
            </ng-select>
            <div class="state-label">State</div>
        </div>
        <div class="required-note">* Required fields</div>
        <div class="submit-button">
            <app-button (click)="handleData()">Submit</app-button>
        </div>
    </div>
</div>
